import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconStages(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M7 4a1 1 0 0 0-2 0v8a1 1 0 1 0 2 0V4Zm3-1a1 1 0 0 1 1 1v16a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1Zm5 1a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0V4Zm4 0a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0V4Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
